import type { Element } from "React";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import "./BlankMarketRunnerDetails.scss";
type Props = {}; //

class BlankMarketRunnerDetails extends Component<Props> {
  render(): Element<"div"> {
    return (
      <div className="markets">
        <span className="blank__runner">
          <FormattedMessage
            tagName="span"
            id={"unsummarized-markets-modal-no-data-available"}
          />
        </span>
      </div>
    );
  }
}

export default BlankMarketRunnerDetails;
